import { useState } from "react";
import { Tag, Modal, Radio, message } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { actualizarEstadoFinalizacion } from "../../../services/informeTecnicoFinal/informeTecnicoFinalService";

const COLOR_FINALIZADO = "#2f9e44";
const COLOR_PENDIENTE = "#c1440e"; // zapote

/**
 * Etiqueta clickeable (con lápiz) que muestra si el informe técnico final
 * de un proyecto está finalizado o pendiente, y permite cambiarlo desde un
 * modal pequeño. `onChange(oid, nuevoEstado)` actualiza la lista en el
 * componente padre sin necesidad de recargar todos los proyectos.
 */
export default function EstadoFinalizacionBadge({ proyecto, onChange, canEdit = true }) {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(proyecto.estadoFinalizacion || "pendiente");
  const [saving, setSaving] = useState(false);

  const finalizado = proyecto.estadoFinalizacion === "finalizado";

  const abrirModal = (e) => {
    e.stopPropagation();
    if (!canEdit) return;
    setValue(proyecto.estadoFinalizacion || "pendiente");
    setOpen(true);
  };

  const handleGuardar = async (e) => {
    e?.stopPropagation?.();
    setSaving(true);
    try {
      await actualizarEstadoFinalizacion(proyecto.oid, value);
      onChange?.(proyecto.oid, value);
      message.success("Estado actualizado");
      setOpen(false);
    } catch (error) {
      console.error("Error al actualizar estado de finalización:", error);
      message.error("No se pudo actualizar el estado");
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Tag
        color={finalizado ? COLOR_FINALIZADO : COLOR_PENDIENTE}
        onClick={abrirModal}
        style={{
          margin: 0,
          borderRadius: 6,
          fontWeight: 500,
          cursor: canEdit ? "pointer" : "default",
          display: "inline-flex",
          alignItems: "center",
          gap: 6
        }}
      >
        {finalizado ? "Informe finalizado" : "Informe en construcción"}
        {canEdit && <EditOutlined style={{ fontSize: 11 }} />}
      </Tag>

      {canEdit && (
        <Modal
          title="Estado del informe técnico final"
          open={open}
          onCancel={(e) => {
            e?.stopPropagation?.();
            setOpen(false);
          }}
          onOk={handleGuardar}
          okText="Guardar"
          cancelText="Cancelar"
          confirmLoading={saving}
          // El modal se abre dentro de la tarjeta clickeable (Card onClick del
          // listado). Los portales de antd bubblean eventos por el árbol de
          // React, no por el DOM, así que sin este wrapper cualquier click
          // dentro del modal (radios, botones del footer) reabría el modal de
          // FileManagerPP de la tarjeta padre.
          modalRender={(node) => <div onClick={(e) => e.stopPropagation()}>{node}</div>}
        >
          <Radio.Group onChange={(e) => setValue(e.target.value)} value={value}>
            <Radio value="pendiente">Informe en construcción</Radio>
            <Radio value="finalizado">Informe finalizado</Radio>
          </Radio.Group>
        </Modal>
      )}
    </>
  );
}
